export default "__VITE_ASSET__CXRMlli5__"